/**
 * Enum configs for coordinating guest board experience using query params
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Yucho Ho
 */
// Key
export const GUEST_QUERY = 'guest'

// Values
export const GUEST_AUTH_ACTION = 'authAction'
